export interface Notification {
  cid: number,
  city: string,
  company_name: string,
  country: string,
  description: string,
  employee_phm: number,
  employee_leader: number,
  job_id: number | string,
  name_project: string,
  notification_date: string,
  notification_id: number,
  notification_type: number,
  order_id: string,
  order_pps: number,
  postcode: string,
  project_id: string,
  purchasing_id: string,
  status: string,
  street: string,
  subject: string | null
}

export interface NotificationList {
  comment_phm: string,
  description: string,
  name: string,
  notification_id: number,
  number_of_pieces: number,
  part: number,
  position: number,
  /** Originalnotation aus dem Altsystem (z. B. "6.1"); leer bei PPS-Zeilen. */
  position_label?: string,
  project_id: string,
  remarks: string,
  side_agreements: string,
  specification: string,
  technical_drawing: string,
}

export class SingleNotification {
  cid: number = 0;
  city: string = '';
  company_name: string = '';
  country: string = '';
  description: string = '';
  employee_phm: number = 0;
  employee_leader: number = 0;
  job_id: number = 0;
  name_project: string = '';
  notification_date: string = '';
  notification_id: number = 0;
  notification_type: number = 0;
  order_id: string = '';
  order_pps: number = 0;
  postcode: string = '';
  project_id: string = '';
  purchasing_id: string = '';
  status: string = '';
  street: string = '';
  subject: string = '';
}

export interface NotificationForm {
  stepI: StepI;
  stepII: StepII;
  stepIII: StepIII;
}

class StepI {
  city: string = '';
  company_name: string = '';
  country: string = '';
  description: string = '';
  job_id: number = 0;
  name_project: string = '';
  notification_date: string = '';
  notification_id?: number = 0;
  notification_type: number = 0;
  order_id: string = '';
  order_pps: number = 0;
  postcode: string = '';
  project_id: string = '';
  purchasing_id?: string = '';
  street: string = '';
  status: string = '';
  subject: string = '';
}

class StepII {
  employee_phm: number = 0;
}

class StepIII {
  employee_leader: number = 0;
}
